import React from "react";

/**
 * DS ChipRound — figma "Chip_round" / "Chip/normal".
 *   round: px8 py4 radius 30 SemiBold 14/22
 *     green  4360:51653 "완료" / 4351:23370 "결제완료" — green/background(10%) + green
 *     orange 4351:24514 "5% 할인" — orange/background(10%) + orange
 *     red    — Red/5 + System/Error (Alert_large 4449:63153 색 재사용; 결제실패)
 *   normal: 4390:51802 "POS" — BG/Paper, px6 py2 radius 4, Text/Primary, max-width 200 ellipsis
 *
 * @param {object} props
 * @param {"green"|"orange"|"red"|"gray"} [props.tone="green"] - normal variant 는 gray 고정
 * @param {React.ReactNode} props.label
 * @param {"round"|"normal"} [props.variant="round"]
 * @param {string} [props.className]
 */
const DSChipRound = ({ tone = "green", label, variant = "round", className = "" }) => {
  const cls = [
    "ds-chip-round",
    variant === "normal" ? "ds-chip-round--normal" : `ds-chip-round--${tone}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={cls} title={variant === "normal" && typeof label === "string" ? label : undefined}>
      {label}
    </span>
  );
};

export default React.memo(DSChipRound);
